import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "micro_calendar",
  "use": "micro_calendar-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"micro_calendar\"><path d=\"M4 0v1h2V0h1v1h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h2V0h1ZM3 2H1v7h8V2H7v1H6V2H4v1H3V2ZM1 4h8v1H1V4Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol